// 3rd party
import * as React from 'react';

interface ExpediaPackageWidgetPreviewFrameProps {
  demoLink: string;
  demoPreviewWidgetStyles: React.CSSProperties;
}

const ExpediaPackageWidgetPreviewFrame = React.memo(
  // tslint:disable-next-line:no-shadowed-variable
  function ExpediaPackageWidgetPreviewFrame(props: ExpediaPackageWidgetPreviewFrameProps): JSX.Element {
    const { demoLink, demoPreviewWidgetStyles } = props;

    return (
      <div key={demoLink} id="packageDealsWidget" style={demoPreviewWidgetStyles}>
        <iframe
          id="widgetIframe"
          src={demoLink}
          width="100%"
          height="100%"
          frameBorder="0"
          scrolling="no"
          tabIndex={-1}
        />
      </div>
    );
  },
);

export { ExpediaPackageWidgetPreviewFrame };
